export default __webpack_public_path__ + "static/media/assetDetails.4a165052.svg";